import { makeStyles } from '@material-ui/core'
import { loginBackground } from 'src/assets/png'

export const useStyles = makeStyles((theme) => ({
  loginContainer: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.app.spacing.base,
    alignItems: 'stretch',
    color: '#FFF',
    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), ${theme.palette.primary.main}`,
    padding: 0,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: 0,
      justifyContent: 'center',
      alignItems: 'center',
      background: '#301e1a'
    },

    '& .login__button': {
      height: 56,
      fontSize: theme.app.typography.body.fontSize,
      fontWeight: 500,
      color: '#FFFFFF',
      width: '100%',
      border: 'none',
      backgroundColor: theme.palette.primary.main,
      boxShadow: '0px 2px 8px rgba(120, 74, 66, 0.15)',
      borderRadius: theme.app.borderRadius.lg,
      marginTop: 20,
      cursor: 'pointer',
      textAlign: 'center',
      transition: 'all 0.2s',
      '&:hover': {
        backgroundColor: '#6a3f38'
      },
      '&:disabled': {
        opacity: 0.6,
        cursor: 'not-allowed'
      }
    }
  },

  loginForm: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '40px 60px',
    gap: theme.app.spacing.xxl,
    flex: 1,
    minWidth: 0,
    maxWidth: 732,
    height: '100vh',
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      maxWidth: 'unset',
      padding: 30,
      gap: theme.app.spacing.xxl,
      height: 'auto'
    },
    '& form': {
      width: '100%'
      // maxWidth: 400
    }
  },

  loginImageSide: {
    width: 708,
    height: '100vh',
    backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${loginBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },

  loginTitleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: 532,
    '& h1': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 900,
      fontSize: 28,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: 0
    }
  },

  loginInfoWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 20,
    width: '100%',
    maxWidth: 400,
    '& h2': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: theme.app.typography.span.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      margin: 0,
      width: '100%'
    }
  },

  loginWrapperInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.app.spacing.sm,
    width: '100%'
  },

  loginInfo: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: theme.app.typography.body.fontSize,
    lineHeight: '150%',
    color: '#FFFFFF',
    margin: 0
  },

  loginLoading: {
    position: 'absolute',
    background: '#fff',
    zIndex: 9999
  },

  loginRegister: {
    fontFamily: theme.app.typography.fontFamily.main,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: theme.app.typography.body.fontSize,
    lineHeight: '150%',
    color: '#dea169',
    cursor: 'pointer',
    textDecoration: 'underline',
    margin: 0
  },

  loginInput: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.app.spacing.xs,
    width: '100%',
    marginTop: theme.app.spacing.base,
    '&:first-of-type': {
      marginTop: 0
    },
    '& label': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: theme.app.typography.label.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.app.typography.paragraph.fontSize
      }
    },
    '& input': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: `${theme.app.spacing.md}px ${theme.app.spacing.base}px`,
      width: '100%',
      height: 48,
      background: theme.app.colors.input.background,
      borderRadius: theme.app.borderRadius.sm,
      border: 'none',
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: theme.app.typography.body.fontSize,
      lineHeight: '150%',
      color: theme.app.colors.text.light,
      boxSizing: 'border-box',
      '&:focus': {
        outline: 'none',
        background: theme.app.colors.input.backgroundFocus
      },
      '&::placeholder': {
        color: 'rgba(250, 250, 250, 0.5)'
      }
    }
  },

  loginShowPassword: {
    marginTop: theme.app.spacing.md,
    width: '100%',
    display: 'flex',
    cursor: 'pointer',
    userSelect: 'none',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '& label': {
      cursor: 'pointer',
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.label.fontSize,
      color: theme.app.colors.text.light,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.app.typography.paragraph.fontSize
      }
    },
    '& .MuiCheckbox-root': {
      color: 'rgba(250, 250, 250, 0.5)',
      '&.Mui-checked': {
        color: theme.palette.primary.main
      }
    }
  },

  loginForgotPassword: {
    marginTop: theme.app.spacing.base,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& p': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: theme.app.typography.label.fontSize,
      lineHeight: '150%',
      color: '#dea169',
      cursor: 'pointer',
      textDecoration: 'underline',
      margin: 0,
      transition: 'color 0.2s',
      '&:hover': {
        color: '#c78a56'
      }
    }
  }
}))
